import BaseModel from './Base.model';

/**
 * Model đại diện cho một người dùng
 */
export default class UserModel extends BaseModel {
  /**
   * Tạo một instance mới của User
   * @param {Object} data - Dữ liệu người dùng
   * @param {string} data.id - ID của người dùng
   * @param {string} data.fullName - Tên người dùng
   * @param {string} data.email - Email
   * @param {string} data.code - Mã người dùng
   * @param {string} data.storeId - ID cửa hàng
   * @param {string} data.username - Tên đăng nhập
   * @param {string} data.phoneNumber - Số điện thoại
   * @param {number} data.status - Trạng thái
   * @param {string} data.role - Vai trò
   * @param {Date} data.createdAt - Ngày tạo
   * @param {Date} data.updatedAt - Ngày cập nhật
   */
  constructor(data = {}) {
    super({
      id: data?.id,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
    });
    this.fullName = data?.fullName || '';
    this.email = data?.email || '';
    this.code = data?.code || '';
    this.storeId = data?.storeId || '';
    this.username = data?.username || '';
    this.phoneNumber = data?.phoneNumber || '';
    this.status = data?.status;
    this.role = data?.role || '';
  }

  /**
   * Trả về tên hiển thị của người dùng
   */
  get displayName() {
    return this.fullName || this.username + ' - ' + this.code;
  }

  /**
   * Trả về trạng thái người dùng dưới dạng text
   */
  get statusText() {
    const statusMap = {
      1: 'Hoạt động',
      2: 'Đang khóa',
    };
    return statusMap[this.status] || 'N/A';
  }

  /**
   * Kiểm tra email hợp lệ
   */
  validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.email);
  }

  /**
   * Kiểm tra số điện thoại hợp lệ
   */
  validatePhoneNumber() {
    const phoneRegex = /^[0-9]{10,11}$/;
    return phoneRegex.test(this.phoneNumber);
  }

  /**
   * Chuyển đổi từ dữ liệu JSON thành đối tượng user
   * @param {Object} json - Dữ liệu JSON
   * @returns {UserModel} - Đối tượng user
   */
  static fromJson(json) {
    return BaseModel.fromJson(json, UserModel);
  }

  /**
   * Chuyển đổi từ danh sách JSON thành danh sách đối tượng user
   * @param {Array} jsonArray - Mảng dữ liệu JSON
   * @returns {Array<UserModel>} - Mảng đối tượng user
   */
  static fromJsonArray(jsonArray) {
    return BaseModel.fromJsonArray(jsonArray, UserModel);
  }

  /**
   * Chuyển đổi đối tượng user thành dữ liệu JSON để gửi lên server
   * @returns {Object} - Dữ liệu JSON
   */
  toJson() {
    return {
      id: this.id,
      fullName: this.fullName,
      email: this.email,
      code: this.code,
      storeId: this.storeId,
      username: this.username,
      phoneNumber: this.phoneNumber,
      status: this.status,
      role: this.role,
    };
  }
}
